import { Injectable } from '@angular/core';
import { VentasRepository } from './ventas.repository';
import { HttpClient } from '@angular/common/http';
import { ListarEntPendAprobRequest, TransaccionEstadoVinculacionRequest } from './componentes/vinculacion-empresas/domain/request/ventas-request';
import { ListarEntPendAprobResponse, TransaccionEstadoVinculacionResponse } from './componentes/vinculacion-empresas/domain/response/ventas-response';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ListarContratoPorLineaRequest, ListarPuertoSemanaRequest, listNaveViajePorPuertoORequest, ReporteLineaContratoRequest, TransaccionPuertoPorSemanaRequest, TransaccionReporteCuotaNaveETDRequest, ListarTEUNaveETDRequest } from './cuota-linea-tipo-contrato/domain/cuota-linea-tipo-contrato.request';
import { ListarContratoPorLineaResponse, ListarPuertoSemanaResponse, listNaveViajePorPuertoOResponse, ReporteLineaContratoResponse, TransaccionPuertoSemanaResponse, TransaccionReporteCuotaNaveETDResponse, ListarTEUNaveETDResponse } from './cuota-linea-tipo-contrato/domain/cuota-linea-tipo-contrato.response';
import { GeneralTransaccionResponse } from 'src/app/operacion/tarja/domain/tarja.response';
import { anularRequerimientoRequest, mantenimientoRequerimientoRequest, rechazarRequerimientoRequest } from './requerimiento/domain/requerimiento.request';

@Injectable({
  providedIn: 'root'
})
export class VentasService extends VentasRepository {  

  constructor(
    private readonly http: HttpClient
  ) {
    super();
  }

  ListarEntidadesPendAprob(fd: ListarEntPendAprobRequest): Observable<ListarEntPendAprobResponse> {
    return this.http.post<ListarEntPendAprobResponse>(`${environment.PATH_API}/ventascomercial/ListarEmpresasPorAprobacion`, fd);
  }
  TransaccionEstVinc(fd: TransaccionEstadoVinculacionRequest): Observable<TransaccionEstadoVinculacionResponse> {
    return this.http.post<TransaccionEstadoVinculacionResponse>(`${environment.PATH_API}/ventascomercial/TransaccionEstadoVinculacion`, fd);
  }
  ListarContrato(fd: ListarContratoPorLineaRequest): Observable<ListarContratoPorLineaResponse> {
    return this.http.post<ListarContratoPorLineaResponse>(`${environment.PATH_API}/ventascomercial/ListarContratoPorLinea`, fd);
  }
  ListarPuertoSemana(fd: ListarPuertoSemanaRequest): Observable<ListarPuertoSemanaResponse> {
    return this.http.post<ListarPuertoSemanaResponse>(`${environment.PATH_API}/ventascomercial/ListarPuertoPorAnioSemana`, fd);
  }
  TransaccionSemanaPuerto(fd: TransaccionPuertoPorSemanaRequest): Observable<TransaccionPuertoSemanaResponse> {
    return this.http.post<TransaccionPuertoSemanaResponse>(`${environment.PATH_API}/ventascomercial/TransaccionPuertoSemana`, fd);
  }

  //#region REQUERIMIENTO

  override mantenimientoRequerimiento(prolrequest: mantenimientoRequerimientoRequest): Observable<GeneralTransaccionResponse> {
    return this.http.post<GeneralTransaccionResponse>(`${environment.PATH_API}/proformainterna/MantProformaInterna`, prolrequest)
  }
  override rechazarRequerimiento(rq: rechazarRequerimientoRequest): Observable<GeneralTransaccionResponse> {
    return this.http.post<GeneralTransaccionResponse>(`${environment.PATH_API}/Proformaexterna/rechazarRequerimiento`, rq)
  }
  override anularRequerimiento(rq: anularRequerimientoRequest): Observable<GeneralTransaccionResponse> {
    return this.http.post<GeneralTransaccionResponse>(`${environment.PATH_API}/proformainterna/anularrequisicion`, rq)
  }

  //#endregion
  ReporteLineaContrato(rq: ReporteLineaContratoRequest): Observable<ReporteLineaContratoResponse> {
    return this.http.post<ReporteLineaContratoResponse>(`${environment.PATH_API}/ventascomercial/ReporteCuotaLinContrato`, rq)
  }
  ListTEUNaveETD(rq: ListarTEUNaveETDRequest): Observable<ListarTEUNaveETDResponse> {
    return this.http.post<ListarTEUNaveETDResponse>(`${environment.PATH_API}/ventascomercial/ListarTEUNaveETD`, rq)
  }
  TransaccionRepCuotaNaveETD(rq: TransaccionReporteCuotaNaveETDRequest): Observable<TransaccionReporteCuotaNaveETDResponse> {
    return this.http.post<TransaccionReporteCuotaNaveETDResponse>(`${environment.PATH_API}/ventascomercial/TransaccionReporteCuotaNaveETD`, rq)
  }
  ListarNavePorPOL(rq: listNaveViajePorPuertoORequest): Observable<listNaveViajePorPuertoOResponse> {
    return this.http.post<listNaveViajePorPuertoOResponse>(`${environment.PATH_API}/ventascomercial/ListarNaveViajePorPuertoOrigen`, rq)
  }
}
